import { render, staticRenderFns } from "./output_edit.vue?vue&type=template&id=1ecf87b6&scoped=true"
import script from "./output_edit.vue?vue&type=script&lang=js"
export * from "./output_edit.vue?vue&type=script&lang=js"
import style0 from "./output_edit.vue?vue&type=style&index=0&id=1ecf87b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf87b6",
  null
  
)

export default component.exports